import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { DealerTiresizeResultsRoute } from "../../../navigation/DealerRoutes";
import { HashLink } from "../../../navigation/HashLink";
import { useRouteParams } from "../../../navigation/useRouteParams";
import { useSearchForm } from "../../../stores/hooks/useSearchForm";
import { useHashState } from "../../../stores/useHashState";
import { InputButton } from "../../../ui/Button/Button";
import { Dialog } from "../../../ui/Dialog/Dialog";
import { DialogHeader } from "../../../ui/Dialog/DialogHeader";
import { Input } from "../../../ui/Input/Input";
import { InputGroup } from "../../../ui/IputGroup/IputGroup";
import { InfoIcon } from "../../../ui/icons/InfoIcon";
import { WheelIcon } from "../../../ui/icons/WheelIcon";

const diagramHash = "#tiresize-diagram" as const;

export const TireSizeInput: FunctionComponent = () => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  const params = useRouteParams(DealerTiresizeResultsRoute);
  const [{ tireSize }, { setTireSize }] = useSearchForm();
  const [diagramIsVisible, { hide }] = useHashState(diagramHash);

  return (
    <>
      <InputGroup>
        <Input
          onChange={(event): void => {
            setTireSize(event.target.value);
          }}
          aria-label="tireSize"
          before={<WheelIcon />}
          defaultValue={tireSize || params?.tireSize}
          name="tireSize"
          placeholder={t("searchForm.enterTireSize")}
        />
        <HashLink hash={diagramHash}>
          <InputButton
            aria-label="viewTireSizeDiagram"
            className="rounded-l-none bg-transparent"
            element="a"
          >
            <InfoIcon />
          </InputButton>
        </HashLink>
      </InputGroup>
      <Dialog
        id="tire-size-diagram-dialog"
        onClose={hide}
        visible={diagramIsVisible}
      >
        <DialogHeader
          onClose={hide}
          subtitle={t("tireSizeDiagram.subtitle")}
          title={t("tireSizeDiagram.title")}
        />
        <section className="px-4 pb-6 max-w-xl">
          <img
            alt="Tire Size Diagram"
            className="mx-auto my-4"
            height={235}
            src={`/static/img/tire_bg_${language}.jpg`}
            width={392}
          />
          <hr className="my-4" />
          <p>{t("tireSizeDiagram.description")}</p>
        </section>
      </Dialog>
    </>
  );
};
